import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';

import { NomOutputFormat } from 'src/app/core/constants';
import { OutputSettings } from 'src/app/core/models/output-settings.models';

import { Observable } from 'rxjs';
import { OutputSettingsFormatEditorComponent } from '../output-settings-format-editor/output-settings-format-editor.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SuiTab, SuiTabsComponent } from '@sui/tabs';
import { SuiEmptyStateComponent } from '@sui/empty-state';

interface FormatTab {
  key: NomOutputFormat;
  label: string;
  icon: any;
}

@Component({
  selector: 'app-feed-level-layout-and-format',
  templateUrl: './feed-level-layout-and-format.component.html',
  styleUrl: './feed-level-layout-and-format.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SuiEmptyStateComponent,
    SuiTabsComponent,
    OutputSettingsFormatEditorComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class FeedLevelLayoutAndFormatComponent implements OnInit {
  @Input() outputSettings: OutputSettings;
  @Input() formatFormGroups: Map<NomOutputFormat, FormGroup>;
  @Input() searchString$: Observable<string>;

  public activeFormatTab: NomOutputFormat = NomOutputFormat.DOCX;
  public visibleTabs: FormatTab[] = [];

  constructor() {}

  ngOnInit(): void {
    this.initializeTabs();
  }

  private initializeTabs(): void {
    const allTabs: FormatTab[] = [
      {
        key: NomOutputFormat.DOCX,
        label: 'output-settings.tab.msword',
        icon: ['fas', 'file-word'],
      },
      {
        key: NomOutputFormat.CSV,
        label: 'output-settings.tab.csv',
        icon: ['fas', 'file-csv'],
      },
      {
        key: NomOutputFormat.HTML,
        label: 'output-settings.tab.html',
        icon: ['fas', 'file-code'],
      },
    ];

    this.visibleTabs = allTabs.filter(
      (tab) => this.formatFormGroups && this.formatFormGroups.has(tab.key),
    );

    if (this.visibleTabs.length > 0) {
      this.activeFormatTab = this.visibleTabs[0].key;
    }
  }

  private readonly translate = inject(TranslateService);

  protected get tabItems(): SuiTab[] {
    return this.visibleTabs.map((tab) => ({
      value: String(tab.key),
      label: this.translate.instant(tab.label),
      icon: tab.icon,
    }));
  }

  protected get activeTabValue(): string {
    return String(this.activeFormatTab);
  }

  protected onTabChange(value: string): void {
    const tab = this.visibleTabs.find((t) => String(t.key) === value);
    if (tab) this.changeFormatTab(tab.key);
  }

  changeFormatTab(formatKey: NomOutputFormat): void {
    this.activeFormatTab = formatKey;
  }

  getFormGroupForFormat(formatKey: NomOutputFormat): FormGroup | undefined {
    return this.formatFormGroups?.get(formatKey);
  }
}
